define(function (require, exports) {

    'use strict';

    function Navigation($stateProvider, $windowProvider, PlatformServiceProvider) {

        PlatformServiceProvider.setWindow($windowProvider.$get());


        var storeWidget=function(widgetName,cb){
            PlatformServiceProvider.setWidgetName(widgetName)
            sessionStorage.setItem("ent-"+widgetName,new Date().getTime());
            if(cb){
                cb();
            }
            
        }


        var NavConfigurer = function (widgetName,useURL) {

            storeWidget(widgetName);
        
            this.useURL=useURL;
            this.widgetName = widgetName;
            var _self = this;
            this._template = "";
            this._popupTemplate = "";



            var widgetConfig = {};
            if(_self.useURL){
             widgetConfig.url = "/"+widgetName;
             }
            else{
            widgetConfig.url = "";
            }
            widgetConfig.views = {};
            widgetConfig.views[widgetName] = {
                template: function () {
                    return _self._template+' <modal-container class="nb-pop-up" listen-back ="test"></modal-container>';
                },
                controller:function($scope,$state){
                    $scope.$state=$state;
                }
                
            }
            widgetConfig.abstract = true;
            widgetConfig.sticky = true;
            widgetConfig.deepStateRedirect = true;
            $stateProvider.state(widgetName, widgetConfig);

            var popupconfig = {};
            if(_self.useURL){
            popupconfig.url = "/popup";
            }
            else{
            popupconfig.url = "";
            }
            popupconfig.views = {};
            popupconfig.views["popup"] = {
                template: function () {
                    return _self._popupTemplate
                },
                controller:function($scope,$state){
                    $scope.$state=$state;
                }
            }
            popupconfig.abstract = true;
            popupconfig.sticky = true;
            popupconfig.deepStateRedirect = true;
            $stateProvider.state(widgetName+".popup", popupconfig);
            this.state = function (name, config) {


                var stateName = this.widgetName + "." + name;
                if(config.onBack){
                    config.onBack=this.widgetName+"."+config.onBack;
                }

                config.referenceURL=config.url+"";
                if(!(_self.useURL || config.useURL)){
                config.url=""
                }

               
                if (config.templateUrl) {
                    var givenTemplateUrl = undefined;
                   var tempUrl=config.templateUrl;
                   if(typeof tempUrl != 'string'){
                    givenTemplateUrl=tempUrl;
                   }else{
                     givenTemplateUrl = function(){ 
                        var x=  PlatformServiceProvider.getTemplateUrl(tempUrl);
                        return x
                    };
                   }
                    

                    if (givenTemplateUrl.mode) {
                        config.templateUrl = function () {
                           var templateToUse;
                            var currentMode = PlatformServiceProvider.getMode();
                            if (currentMode == "desktop") {
                                 templateToUse = givenTemplateUrl.mode.desktop ? givenTemplateUrl.mode.desktop : givenTemplateUrl.mode.mobile
                                return PlatformServiceProvider.getTemplateUrl(templateToUse)
                            } else if (currentMode == "mobile") {
                                 templateToUse = givenTemplateUrl.mode.mobile ? givenTemplateUrl.mode.mobile : givenTemplateUrl.mode.desktop
                                return PlatformServiceProvider.getTemplateUrl(templateToUse)
                            } else if(currentMode=="native") {
                                 templateToUse = givenTemplateUrl.mode.native ? givenTemplateUrl.mode.native : givenTemplateUrl.mode.mobile
                                
                                return PlatformServiceProvider.getTemplateUrl(templateToUse);
                            }else{
                                console.error("No Proper Mode defined for current mode -> "+currentMode)
                            }

                        }
                    }else{
                        config.templateUrl=givenTemplateUrl;
                    }
                }


                var viewObject = {};
                if (config.template) {
                    viewObject.template = template;
                } else if (config.templateUrl) {
                    viewObject.templateUrl = config.templateUrl
                }
                if (config.controller) {
                    viewObject.controller = config.controller;
                }
                config.views = {};
                config.views[name] = viewObject;
                if(config.isSticky){
                    config.sticky="true";
                    config.deepStateRedirect="true";
                }
                if(config.notMainWidget){
                    config.notMainWid="true";
                }



                if (config.template)
                    delete config.template;
                if (config.templateUrl)
                    delete config.templateUrl;
                if (config.controller)
                    delete config.controller;
                if (config.isSticky){
                    delete config.isSticky;
                }

                config.onEnter=function($state,$previousState){
                    $state.$custom_$memo=""
                    $previousState.forget("MAIN-COVER");

                }


                $stateProvider.state(stateName, config);



           _self._template = _self._template + '<div  class="anim-in-out anim-fade" data-anim-sync="true" data-anim-speed="10" ui-view="' + name + '" ng-show="(($state.includes(\'' + this.widgetName + '.' + name + '\'))||($state.$custom_$memo==\''+this.widgetName + '.' + name+'\'))"> </div>';
           

                var popup = config.mode ? config.mode.desktop : undefined;
                if (popup) {
                    var popupStateName = _self.widgetName+".popup." + name

                   
                    var newConfig = {};
                    var keys = Object.keys(config);
                    for (var i = 0; i < keys.length; i++) {
                        newConfig[keys[i]] = config[keys[i]];
                    }
                    newConfig.name = popupStateName;
                    if(!_self.useURL){
                     newConfig.url = "";
                    }
                    newConfig.alias=stateName;
                    newConfig.onEnter=function($state,$previousState){

                    }

                    _self._popupTemplate = _self._popupTemplate + '<div class="anim-in-out anim-fade" data-anim-sync="true" data-anim-speed="10" ui-view="' + name + '" ng-show="(($state.includes(\'' + popupStateName + '\'))||($state.$custom_$memo==\''+popupStateName +'\'))"> </div>';
                   
                    $stateProvider.state(popupStateName, newConfig);

                    
                }

                return _self;
            }
            return this;

        }

        this.getConfig = function (widgetName,useURL) {
            return new NavConfigurer(widgetName,useURL);
        }

        this.$get = {

        }


    }

    exports.Navigation = Navigation;

});


// WEBPACK FOOTER //
// ./src/feature-hdfc-navigation/scripts/service/Navigation.js